import type { Variant } from '@storefront/lib-global/codegen/types';
import { StockStatus } from '@storefront/lib-global/codegen/types';

export const hasSizeBackInStockNotificationsStatus = (
  size: string,
  variants: Variant[],
  checkEnabled: boolean,
): boolean => {
  // Filter variants to only include those matching the given size
  const sizeVariants = variants.filter((variant) => variant.size === size);

  // If all filtered variants are not out of stock, return false
  const allOutOfStock = sizeVariants.every((variant) => variant.stock.status === StockStatus.OUTOFSTOCK);
  if (!allOutOfStock) return false;

  // Return true only if all notification statuses match, based on checkEnabled parameter being true or false
  return sizeVariants.every((variant) =>
    checkEnabled ? variant.backInStockNotificationsEnabled : !variant.backInStockNotificationsEnabled,
  );
};
